export default __webpack_public_path__ + "static/media/sch7_w320.31efc842.jpg";